var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "rbv-ng-inactive-accounts" }, [
    _c("div", { staticClass: "page" }, [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "layout-column flex-center" }, [
          _vm._m(0),
          _c("div", [
            _c("p", [_vm._v(" " + _vm._s(_vm.user.firstName) + " ")]),
            _c("p", [
              _vm._v(
                " Currently your administrator has not assigned any accounts to you, so you are not allowed to view RFP or Bid data. We am sure that will soon change. "
              ),
            ]),
            _c("p", [
              _vm._v(
                " " +
                  _vm._s(_vm.user.firstName) +
                  ", in an effort to helo you understand ReadyBid and all it can do we have prepared the ReadyBid "
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://invis.io/QVV3NJ78SRD#/396121604_Corporate_User_Guide-01",
                  },
                },
                [_vm._v("TMC Tutorial")]
              ),
              _vm._v(" for your review "),
            ]),
            _c("p", [_vm._v("ReadyBid Support")]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("info_outline")]),
      _c("div", { staticClass: "flex column" }, [
        _c("div", { staticClass: "title" }, [_vm._v("Hmmm,")]),
        _c("div", { staticClass: "sub-title" }, [_vm._v("No Bid Manager")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }